/**
 * Accepts event triggers and fans it out to all listeners.
 */
import {
    ButtonClickObject,
    GoogleOrder,
    HgsCart,
    HgsCartItem,
    HgsProductItem,
} from "../types";
import * as Google from "./google-events";
import * as Bing from "./bing-events";

export function triggerViewItemEvent(itemsObject: HgsProductItem) {
    Google.triggerViewItemEvent(itemsObject);
}

export function triggerAddToCartEvent(itemsObject: HgsCartItem) {
    Google.triggerAddToCartEvent(itemsObject);
    Bing.triggerAddToCartEvent(itemsObject);
}

export function triggerPWAInstalledEvent() {
    Google.triggerPWAInstalled();
}

export function triggerPWAInstallPromptedEvent() {
    Google.triggerPWAInstallPrompted();
}

export function triggerBeginCheckoutEvent(cart: HgsCart) {
    Google.triggerBeginCheckout(cart);
}

export function triggerButtonClickEvent(e: ButtonClickObject) {
    Google.triggerButtonClickEvent(e);
}

export function triggerCheckoutCompleteEvent(order: GoogleOrder) {
    Google.triggerCheckoutCompleteEvent(order);
    Bing.triggerCheckoutCompleteEvent(order);
}
